export const clientEvents = {
  // Checkout actions listens to this events to enable/disable the place order button
  // whenever the other components are collapsed/expanded.
  CheckoutEnablement: 'checkoutEnablement',
  // Used to handle GWP errors so that when CartActions is in error state it can dispatch and tell
  // the GWP component to highlight and scroll to the error.
  SecureCheckoutGWPSelection: 'secureCheckoutGWPSelection',
  // On place order click, CheckoutActions requests order validation from PaymentMethod
  RequestOrderValidation: 'orderValidation',
  // Once validation is done, PaymentMethod dispatches order validation status
  IsOrderValid: 'orderValid',
  // Once Store is selected and clicked on continue button
  BirthdayStoreSelected: 'birthdayStoreSelected',
  // Focus on a specific fulfillment module
  FOCUS_MODULE: 'focusModule'
};
